/**
 * 业务应用的通用配置文件
 * 标记有<必填项>的必须提供，因为架构要统一控制
 * 业务应用也可以在该文件中添加业务需要的额外的属性
 * @author who?
 * @version 1.0.0, 2019-03-16
 */

import store from "@/store";

/**
 * <必填项>
 * 业务目录名称
 * 即在views下的业务代码的根目录名称(和base,common目录同级)
 * 也是在assets目录下的业务通用样式的根目录名称(和base目录同级)
 */
export const bizFolderName = "console";

/**
 * 如果业务应用需要自己的通用样式，请在这里导入
 * 注意，必须放在assets目录下的业务目录{bizFolderName}下
 * 如果只是个别业务需要的样式，请在个别业务代码vue文件中编写样式
 */
// import '@/assets/{bizFolderName}/style/xxx.scss'

/**
 * 仅控制台使用, 用于访问服务端提供的:
 * 1 Druid数据库连接池监控页面
 * 2 Swagger的API管理页面
 * 3 控制台启动的微服务管理监控页面
 */
// export const apiServerUrl = 'http://192.168.0.161:8100/famp'; // 互联网演示环境
// export const apiServerUrl = '/service'; // 线上环境 网关版配置
// export const apiServerUrl = '/saas'; // 线上环境 网关版配置
// export const apiServerUrl = 'http://127.0.0.1:8100/visit';
export const apiServerUrl = serviceURL.url;
export const docsApiServerUrl = serviceURL.attachModelUrl;
export const voiceUrl = serviceURL.voiceUrl;

// 外交部项目中模拟查验接口
export let inspectionWebSocketUrl = "ws://127.0.0.1:8300/production/simulation/inspection";
// 正式环境查验接口
// export let inspectionWebSocketUrl = "wss://127.0.0.1:3105/verify";

/**
 * <必填项>
 * 业务页面布局
 * 可以根据业务需要自行修改该布局
 * 仅在本文件中使用，无需export
 */

// const bizLayout = () =>
//   import(`@/views/common_module/${bizFolderName}/page/frame/Layout.vue`);
const bizLayout = () =>
  import(`@/views/common_module/${bizFolderName}/page/frame/Layout.vue`);

const appleLayout = () =>
  import(`@/views/common_module/${bizFolderName}/page/frame/Layout.vue`);

const bizLayout1 = () =>
  import(`@/views/common_module/base/page/layout1.vue`);

// 指定机构个性化页面的路径，页面中可以接收当前机构信息，参数名为data，举例：
// name: 'compBizSumOrg',
//    props: {
//      data: Object,
//    },
// 具体请参考src/views/compBizSumOrg.vue
export const sumOrgPath = '@/views/compBizSumOrg.vue';

/**
 * api鉴权, 完全可由业务自行定义鉴权规则, 可通过matching参数默认值统一设置
 * @param {String} apiTag api标签/匹配字符串/正则表达式
 *                          例如：sum.student.selectPage, sum.student.insert  相等匹配
 *                          例如：sum.student.select, sum.student.update      前缀匹配
 *                          例如：student.update, teacher.select              中间匹配
 *                          例如：/^\d+$/, /\bhi\b/gi                         正则匹配
 * @param {String} matching 匹配控制参数, 完全可由业务自定义, 默认为'0', 即不鉴权
 *                           '0'表示不鉴权
 *                           '1'表示相等匹配 api === apiTag
 *                           '2'表示前缀匹配 api === apiTag || api.indexOf(apiTag) === 0
 *                           '3'表示包含匹配 api === apiTag || api.indexOf(apiTag) >= 0
 *                           '4'表示正则匹配 api === apiTag || api.match(new RegExp(apiTag)) // apiTag为正则表达式
 *                           'x'由业务自行扩展
 * @returns {Boolean} true表示有权, false表示无权
 */
export const apiAuth = (apiTag, matching = "0") => {
  switch (matching) {
    case "0":
      return true;
    case "1":
      return store.state.apis.some(api => api === apiTag);
    case "2":
      return store.state.apis.some(
        api => api === apiTag || api.indexOf(apiTag) === 0
      );
    case "3":
      return store.state.apis.some(
        api => api === apiTag || api.indexOf(apiTag) >= 0
      );
    case "4":
      return store.state.apis.some(
        api => api === apiTag || api.match(new RegExp(apiTag))
      );
    default:
      return store.state.apis.some(api => api === apiTag);
  }
};

/**
 * 业务上不需要在菜单树显示的路由，即需要隐藏的菜单
 * 这些菜单必须在服务端授权，否则前端权限校验失败
 * 目前用于菜单过渡，例如有个菜单加载了很多内容，由于数据变化需要重新加载，
 * 如果通过代码加载非常繁琐，因此跳转该过渡页面，由VUE框架清理缓存，再由
 * 过渡页面跳转到该菜单页面，完成重新加载，代码实现简单。
 * 此处设置为path属性的数组，例如：[ '/sys/dict', '/qrtz/schedule', ...]
 */
export const bizHiddenRouter = [];

/**
 * <必填项>
 * 业务常量路由，也就是允许匿名访问的页面, meta: { anonymous: true }
 * 登录页面是默认要有的，业务上自行添加其他页面
 */
export const bizConstantRouter = [
  // 登录页面可以匿名访问
  {
    path: "/",
    name: "login",
    component: () =>
      // import(`@/views/aiAgent/Layout.vue`),
      import(`@/views/common_module/console/page/frame/Login.vue`),
    meta: {
      anonymous: true
    }
  },
  // {
  //   path: "/testimg",
  //   name: "testimg",
  //   component: () =>
  //     // import(`@/views/aiAgent/Layout.vue`),
  //     import(`@/views/testimghandle.vue`),
  //   meta: {
  //     anonymous: true
  //   }
  // },
  {
    path: "/autologin",
    name: "autologin",
    component: () =>
      import(`@/views/common_module/${bizFolderName}/page/frame/AutoLogin.vue`),
    meta: {
      anonymous: true
    }
  },
  {
    path: `/console/dashboard`,
    component: () => import(`@/views/aiAgent/Layout.vue`),
  },
  {
    // 申报首页
    path: `/index`,
    name: "index",
    component: () => import(`@/views/aiAgent/Layout.vue`),
  },
  {
    // 操作手册
    path: "/operationManual",
    name: '/operationManual',
    component: bizLayout1,

    children: [{
      path: '/operationManual/test',
      name: 'operationManual/test',
      component: () =>
        import("@/views/common_module/console/page/frame/test.vue"),
      meta: {
        anonymous: true
      }

    }]
  },
  /*  {
      path: `/sys/flow/flowDesigner`,
      component: bizLayout,
      children: [{
        // 首页2 - 菜单上方
        path: `/sys/flow/flowDesigner`,
        name: "/sys/flow/flowDesigner",
        component: () =>
          import(`@/views/common_module/${bizFolderName}/page/flow/flowDesigner.vue`),
        meta: {
          anonymous: true
        }
      }]
    },*/
  {
    path: `/sys/flow/flowDesigner`,
    props: (route) => ({ ...route.query }),
    name: "flowDesign",
    component: () =>
      import(`@/views/common_module/console/page/newflow/MainProcessDesign.vue`),
    meta: {
      anonymous: true
    }
  }
];
export const bizAsyncRouter = [];
